import type { QueryClient, QueryKey } from '@tanstack/react-query'

const windows = new Map<string, { again: boolean }>()

/**
 * Refresh a query now, then at most once per `delayMs` while writes keep
 * arriving, and once more after the last of them.
 *
 * For writes that arrive in bursts: a 650-photo evidence upload used to refetch
 * the claim's whole attachment list after every photo, 650 times over a list
 * growing to 650 rows, each refetch competing with the uploads for the same
 * connection (WPS-223). A single upload still refreshes straight away.
 */
export function invalidateSoon(qc: QueryClient, queryKey: QueryKey, delayMs = 3000): void {
  const id = JSON.stringify(queryKey)
  const open = windows.get(id)
  if (open) {
    open.again = true
    return
  }
  const burst = { again: false }
  windows.set(id, burst)
  void qc.invalidateQueries({ queryKey })
  const close = () => {
    if (!burst.again) {
      windows.delete(id)
      return
    }
    burst.again = false
    void qc.invalidateQueries({ queryKey })
    setTimeout(close, delayMs)
  }
  setTimeout(close, delayMs)
}
